import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 성능 측정을 위해 함수 전달 (예: reportWebVitals(console.log))
// 또는 분석 엔드포인트로 전송. 자세한 내용: https://bit.ly/CRA-vitals
reportWebVitals();
